import "./CosmicChart.css";

const glyphs = [
  { label: "Aries", glyph: "♈", color: "#f87171" },
  { label: "Taurus", glyph: "♉", color: "#fb923c" },
  { label: "Gemini", glyph: "♊", color: "#facc15" },
  { label: "Cancer", glyph: "♋", color: "#34d399" },
  { label: "Leo", glyph: "♌", color: "#38bdf8" },
  { label: "Virgo", glyph: "♍", color: "#818cf8" },
  { label: "Libra", glyph: "♎", color: "#c084fc" },
  { label: "Scorpio", glyph: "♏", color: "#f472b6" },
  { label: "Sagittarius", glyph: "♐", color: "#fb7185" },
  { label: "Capricorn", glyph: "♑", color: "#f97316" },
  { label: "Aquarius", glyph: "♒", color: "#a3e635" },
  { label: "Pisces", glyph: "♓", color: "#60a5fa" },
];

const planetBeacons = [
  { label: "Mercury", degree: "18° SG", radius: 140, hue: 210, angle: 20 },
  { label: "Venus", degree: "02° CP", radius: 165, hue: 320, angle: 95 },
  { label: "Mars", degree: "27° AQ", radius: 195, hue: 35, angle: 190 },
  { label: "Jupiter", degree: "11° AR", radius: 230, hue: 180, angle: 310 },
];

const orbitBands = [
  { radius: 245, thickness: 16, opacity: 0.35 },
  { radius: 265, thickness: 10, opacity: 0.25 },
  { radius: 285, thickness: 6, opacity: 0.15 },
];

const tickMarks = Array.from({ length: 48 }).map((_, index) => ({
  angle: index * 7.5,
  major: index % 4 === 0,
}));

const wavePulses = [
  { radius: 120, delay: 0 },
  { radius: 170, delay: 4 },
  { radius: 210, delay: 8 },
];

const CosmicChart = () => {
  return (
    <div className="cosmic-chart" aria-hidden>
      <div className="cosmic-chart__halo" />
      <div className="cosmic-chart__layer cosmic-chart__layer--stars" />
      <div className="cosmic-chart__layer cosmic-chart__layer--nebula" />
      <div className="cosmic-chart__layer cosmic-chart__layer--grid" />

      <div className="cosmic-chart__rim">
        {tickMarks.map((tick) => (
          <span
            key={`tick-${tick.angle}`}
            className={`cosmic-chart__tick${tick.major ? " cosmic-chart__tick--major" : ""}`}
            style={{ "--tick-angle": `${tick.angle}deg` }}
          />
        ))}
      </div>

      <div className="cosmic-chart__orbit-band">
        {orbitBands.map((band) => (
          <span
            key={`band-${band.radius}`}
            className="cosmic-chart__orbit-layer"
            style={{
              "--band-radius": `${band.radius}px`,
              "--band-thickness": `${band.thickness}px`,
              "--band-opacity": band.opacity,
            }}
          />
        ))}
      </div>

      <svg className="cosmic-chart__dial" viewBox="0 0 500 500">
        <defs>
          <radialGradient id="dialGradient" cx="50%" cy="50%" r="60%">
            <stop offset="0%" stopColor="#c084fc" stopOpacity="0.7" />
            <stop offset="55%" stopColor="#312e81" stopOpacity="0.75" />
            <stop offset="100%" stopColor="#0f172a" stopOpacity="0.95" />
          </radialGradient>
        </defs>
        <circle cx="250" cy="250" r="220" fill="url(#dialGradient)" opacity="0.95" />
        {[90, 130, 170, 210].map((radius) => (
          <circle
            key={`ring-${radius}`}
            cx="250"
            cy="250"
            r={radius}
            className="cosmic-chart__ring"
          />
        ))}

        {/* spokes */}
        {Array.from({ length: 24 }).map((_, index) => (
          <line
            key={`spoke-${index}`}
            x1="250"
            y1="250"
            x2="250"
            y2="30"
            className="cosmic-chart__spoke"
            style={{ transform: `rotate(${index * 15}deg)` }}
          />
        ))}
      </svg>

      <div className="cosmic-chart__glyphs">
        {glyphs.map((item, index) => (
          <div
            key={item.label}
            className="cosmic-chart__glyph-slot"
            style={{
              "--glyph-angle": `${(360 / glyphs.length) * index}deg`,
              "--glyph-color": item.color,
            }}
          >
            <span className="cosmic-chart__glyph-icon">{item.glyph}</span>
            <span className="cosmic-chart__glyph-label">{item.label}</span>
          </div>
        ))}
      </div>

      <div className="cosmic-chart__waves">
        {wavePulses.map((pulse) => (
          <span
            key={`pulse-${pulse.radius}`}
            className="cosmic-chart__wave"
            style={{
              "--wave-radius": `${pulse.radius}px`,
              animationDelay: `${pulse.delay}s`,
            }}
          />
        ))}
      </div>

      <div className="cosmic-chart__beacons">
        {planetBeacons.map((planet) => (
          <div
            key={planet.label}
            className="cosmic-chart__beacon"
            style={{
              "--beacon-radius": `${planet.radius}px`,
              "--beacon-hue": planet.hue,
              "--beacon-angle": `${planet.angle}deg`,
            }}
          >
            {/* <span className="cosmic-chart__beacon-spark" />
            <div className="cosmic-chart__beacon-label">
              <strong>{planet.label}</strong>
              <span>{planet.degree}</span>
            </div> */}
          </div>
        ))}
      </div>

      <div className="cosmic-chart__core">
        <div className="cosmic-chart__core-orbit" />
        <div className="cosmic-chart__core-sun">
          <span>Heliocentric</span>
        </div>
      </div>
    </div>
  );
};

export default CosmicChart;

